import { DEVICES_SIZE } from '@/enums'

const initialState = () => ({
  item: {
    timestamp: null,
    pageTitle: null,
    pageUrl: null,
    clickUrl: null,
    browser: null,
    screenSize: {
      height: null,
      width: null,
    },
    device: null,
    attributes: [],
    bot: [],
  },
})

export const state = initialState()

export const getters = {
  fullHistory: (state, getters, rootState) => {
    const fullHistory = {
      ...state.item,
    }

    // merge bot history if exists with history attributes
    if (rootState.Bot.botHistory) {
      const { attributes = [] } = fullHistory
      fullHistory.attributes = [...attributes, ...rootState.Bot.botHistory]
    }

    return fullHistory
  },
}

export const mutations = {
  SET_HISTORY_ITEM(state, payload = {}) {
    const screenSize = window.screen
    const device = Object.keys(DEVICES_SIZE).find(
      (key) => screenSize.width >= DEVICES_SIZE[key],
    )

    state.item = {
      pageTitle: document.title,
      pageUrl: window.location.href,
      ...payload,
      timestamp: new Date(),
      device,
      browser: navigator.userAgent,
      screenSize: {
        height: screenSize.height,
        width: screenSize.width,
      },
    }
  },
  ADD_HISTORY_ATTRIBUTES(state, payload = []) {
    const { attributes = [] } = state.item
    state.item.attributes = [...attributes, ...payload]
  },
  RESET(state) {
    const newState = initialState()
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key]
    })
  },
}

export const actions = {
  mergeBotHistory({ rootState, commit }) {
    if (rootState.Bot.botHistory) {
      commit('ADD_HISTORY_ATTRIBUTES', rootState.Bot.botHistory)
      commit('Bot/SET_BOT_HISTORY', null, { root: true })
    }
  },
  /**
   * Reset state
   * @param {*} { commit }
   */
  reset({ commit }) {
    commit('RESET')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
